import { Injectable } from "@angular/core";
import { AuthenticationModel, ChatConverter, ChatEndPoints, CheckUtils, ConversationsApiData, ConversationsModel, ConversationsPageApiData, ConversationStateVoData, EncryptStorageEvent, logger, OrganizationModel } from "../..";
import { Events } from "ionic-angular";
import { ConversationsByJabberIdsApiData } from "../../end-points-dto/api-dto/chat/conversations-by-jabber-ids-api-data";
import { ConversationsStatisticsProvider } from "./conversations-statistics-provider";
import { ConversationsByIdsApiData } from "../../end-points-dto/api-dto/chat/conversations-by-ids-api-data";
import { WorkItemEndPoints } from "../../endpoints/work-item-end-points";
import { ApplicationEndPoints } from "../../endpoints/application-end-points";
var ConversationsProvider = /** @class */ (function () {
    function ConversationsProvider(_chatEndPoints, _workItemEndPoints, _applicationEndPoints, _model, _organizationModel, _authModel, _conversationsStatisticsProvider, events) {
        this._chatEndPoints = _chatEndPoints;
        this._workItemEndPoints = _workItemEndPoints;
        this._applicationEndPoints = _applicationEndPoints;
        this._model = _model;
        this._organizationModel = _organizationModel;
        this._authModel = _authModel;
        this._conversationsStatisticsProvider = _conversationsStatisticsProvider;
        this.events = events;
        this._ready = false;
        this.bind();
    }
    Object.defineProperty(ConversationsProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsProvider.prototype.bind = function () {
        var _this = this;
        this.events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
        this.events.subscribe(this._organizationModel.event.URI_CHANGED, function () {
            _this._model.clear(false, true);
        });
        this.events.subscribe(this._model.event.LOADED, function () {
            _this._ready = true;
            _this.events.publish(ConversationsProviderEvent.READY);
        });
    };
    Object.defineProperty(ConversationsProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    //Page Loader of conversations
    //Page Loader of conversations
    ConversationsProvider.prototype.loadPage = 
    //Page Loader of conversations
    function (offset, limit, callback) {
        var _this = this;
        this._chatEndPoints.conversationsPage(new ConversationsPageApiData(offset, limit, this._authModel.authenticationToken))
            .then(function (res) { return _this.onLoad(res.items, callback); })
            .catch(function (err) {
            _this.onLoad(null, callback);
            logger.info(err);
        });
    };
    ConversationsProvider.prototype.getByItemId = function (itemId, cpId, callback) {
        var _this = this;
        if (typeof itemId === "string" && typeof cpId === "string") {
            this._workItemEndPoints.getIdByExternalId(itemId).then(function (itemIdAsNumber) {
                _this._applicationEndPoints.getIdByExternalId(cpId).then(function (cpIdAsNumber) {
                    _this._getByItemId(itemIdAsNumber, cpIdAsNumber, callback);
                }).catch(function () {
                    console.error("convert application external id to id");
                });
            }).catch(function () {
                console.error("convert work-item external id to id");
            });
        }
        else if (typeof itemId === "number" && typeof cpId === "number") {
            this._getByItemId(itemId, cpId, callback);
        }
    };
    ConversationsProvider.prototype._getByItemId = function (itemId, cpId, callback) {
        var _this = this;
        this._chatEndPoints.getConversationRoomsByItemId(this._authModel.authenticationToken, itemId, cpId)
            .then(function (res) { return _this.onLoad(res, callback); })
            .catch(function (err) {
            _this.onLoad(null, callback);
            logger.info(err);
        });
    };
    //Get Conversations VO by JabberIds
    //Get Conversations VO by JabberIds
    ConversationsProvider.prototype.get = 
    //Get Conversations VO by JabberIds
    function (conversationsId, callback, localOnly) {
        var result = [];
        if (CheckUtils.isEmpty(conversationsId))
            return result;
        //Check conversations on model
        var toLoad = new Set();
        for (var _i = 0, _a = Array.from(conversationsId); _i < _a.length; _i++) {
            var conversationId = _a[_i];
            var conversation = this._model.get(conversationId);
            if (CheckUtils.isEmpty(conversation))
                toLoad.add(conversationId);
            else
                result.push(conversation);
        }
        //Return all defined conversations
        if (CheckUtils.isEmpty(toLoad) || localOnly) {
            callback(result);
        }
        else {
            //Load undefined conversations
            this.load(toLoad, function (res) {
                callback(result.concat(res));
            });
        }
    };
    //Todo refactor is not create but add and set as current
    //Todo refactor is not create but add and set as current
    ConversationsProvider.prototype.create = 
    //Todo refactor is not create but add and set as current
    function (conversation) {
        if (CheckUtils.isEmpty(conversation) || CheckUtils.isEmpty(conversation.uid))
            return null;
        conversation.lastPosted = new Date().getTime();
        this._model.add(conversation);
        //this._model.setCurrent(conversation.uid);
        return conversation;
    };
    //Loader of undefined conversations
    //Loader of undefined conversations
    ConversationsProvider.prototype.load = 
    //Loader of undefined conversations
    function (conversationsId, callback) {
        var _this = this;
        this._chatEndPoints.conversationsByJabberIds(new ConversationsByJabberIdsApiData(Array.from(conversationsId), this._authModel.authenticationToken))
            .then(function (res) {
            if (callback != null)
                _this.onLoad(res, callback);
        }).catch(function (err) {
            if (callback != null)
                _this.onLoad(null, callback);
            logger.info(err);
        });
    };
    ConversationsProvider.prototype.onLoad = function (conversationsApiResult, callback) {
        var _this = this;
        var conversations = [];
        if (CheckUtils.isEmpty(conversationsApiResult)) {
            callback(conversations);
            return;
        }
        var conversationsId = new Set();
        //Convert from API DTO to VO
        for (var _i = 0, conversationsApiResult_1 = conversationsApiResult; _i < conversationsApiResult_1.length; _i++) {
            var conversation = conversationsApiResult_1[_i];
            var conversationVo = ChatConverter.convertToConversationVoData(conversation);
            conversationVo.state = ConversationStateVoData.SENDED;
            conversations.push(conversationVo);
            conversationsId.add(conversationVo.id);
        }
        this.getUnreadMessageJabberIds(conversations, conversationsId, this._organizationModel.cpId);
        //Load Statistics
        this._conversationsStatisticsProvider.load(conversations, function (conversationsWithStastistics) {
            _this._model.addAll(conversationsWithStastistics);
            if (!CheckUtils.isEmpty(callback))
                callback(conversationsWithStastistics);
        });
    };
    ConversationsProvider.prototype.getFilteredConversationRoomIds = function (offset, limit, conversationState, conversationVisibility, myConversations, myInbox, callback) {
        var _this = this;
        this._chatEndPoints.getFilteredConversationRoomIds(this._authModel.authenticationToken, offset, limit, conversationState, conversationVisibility, myConversations, myInbox)
            .then(function (res) {
            if (res.total == 0) {
                _this.onLoad(null, callback);
            }
            else {
                _this._chatEndPoints.getConversationRoomsByIds(new ConversationsByIdsApiData(res.items, _this._authModel.authenticationToken))
                    .then((function (res) {
                    _this.onLoad(res, callback);
                })).catch(function (err) {
                    if (callback != null)
                        _this.onLoad(null, callback);
                    logger.info(err);
                });
            }
        }).catch(function (err) {
            if (callback != null)
                _this.onLoad(null, callback);
            logger.info(err);
        });
    };
    ConversationsProvider.prototype.getUnreadMessageJabberIds = function (conversations, conversationsId, cpId) {
        var _this = this;
        this._chatEndPoints.getUnreadMessageJabberIds(new ConversationsApiData(Array.from(conversationsId), this._authModel.authenticationToken, cpId))
            .then(function (res) {
            for (var _i = 0, conversations_1 = conversations; _i < conversations_1.length; _i++) {
                var conversation = conversations_1[_i];
                conversation.unReadMessagesId = (res == null || !res.has(conversation.id)) ? [] : res.get(conversation.id);
            }
            _this._model.addAll(conversations);
        })
            .catch(function (err) {
            logger.info(err);
        });
    };
    ConversationsProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ConversationsProvider.ctorParameters = function () { return [
        { type: ChatEndPoints, },
        { type: WorkItemEndPoints, },
        { type: ApplicationEndPoints, },
        { type: ConversationsModel, },
        { type: OrganizationModel, },
        { type: AuthenticationModel, },
        { type: ConversationsStatisticsProvider, },
        { type: Events, },
    ]; };
    return ConversationsProvider;
}());
export { ConversationsProvider };
export var ConversationsProviderEvent;
(function (ConversationsProviderEvent) {
    ConversationsProviderEvent["READY"] = "conversation-provider:ready";
    ConversationsProviderEvent["LOCK"] = "conversation-provider:lock";
})(ConversationsProviderEvent || (ConversationsProviderEvent = {}));
//# sourceMappingURL=conversations-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/chat/conversations-provider.js
// module id = 151
// module chunks = 14